import React from 'react';
import { FiShoppingCart, FiTruck, FiUsers, FiBarChart2 } from 'react-icons/fi';

const useCases = [
  {
    icon: FiShoppingCart,
    title: 'E-commerce Checkout',
    description:
      'Validate and auto-fill Sri Lankan addresses at checkout for faster conversions',
  },
  {
    icon: FiTruck,
    title: 'Logistics & Delivery',
    description:
      'Route optimization with accurate district and province mapping for delivery systems',
  },
  {
    icon: FiUsers,
    title: 'CRM & Forms',
    description:
      'Smart address auto-complete in registration forms and customer databases',
  },
  {
    icon: FiBarChart2,
    title: 'Analytics & Reporting',
    description:
      'Regional postal filtering and province-level analytics for business insights',
  },
];

const UseCases = () => {
  return (
    <section className="bg-white/[0.02] py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="section-heading text-4xl md:text-5xl font-heading font-bold text-center mb-16 gradient-text">
          Built for Real-World Use
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {useCases.map((useCase, index) => {
            const Icon = useCase.icon;
            return (
              <div
                key={index}
                className="use-case-card bg-white/[0.04] rounded-2xl p-8 border border-white/[0.08] hover:bg-white/[0.07] transition-all duration-300"
              >
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mb-6">
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-heading font-semibold text-white mb-3">
                  {useCase.title}
                </h3>
                <p className="text-slate-400 font-body leading-relaxed">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
